export enum SubscriptionPlanTypeEnum {
	Regular = 1,
	Emergency = 2
}

export enum SubscriptionPlanAvailableTimeEnum {
	"Day" = 1,
	"Night" = 2,
	"FullDay" = 3,
}

export enum SubscriptionPlanAreaAvailableTimeEnum {
	"Day" = 1,
	"Night" = 2,
	"FullDay" = 3,
}
